import React, { useState } from "react";
import { ReactComponent as OneIcon } from "../../../../assets/one.svg";
import { ReactComponent as TwoIcon } from "../../../../assets/two.svg";
import { ReactComponent as ThreeIcon } from "../../../../assets/three.svg";
import { ReactComponent as FourIcon } from "../../../../assets/four.svg";
import { ReactComponent as ModalIcon } from "../../../../assets/modalLogo.svg";
import { ReactComponent as CloseIcon } from "../../../../assets/iconamoon_close.svg";
import CustomButton from "../../../../components/CustomButton";
import { useDisclosure } from "@mantine/hooks";
import { Modal, Button } from "@mantine/core";
import CheckEligibilityModal from "./modal/EligibilityModal";
const CheckEligibility = () => {
  const [opened, { open, close }] = useDisclosure(false);
  const [openEligibility, setOpenEligibility] = useState(false);

  const clearLocalStorage = () => {
    const keysToRemove = [
      "claimType",
      "flightDetailsData",
      "flightCheckData",
      "claimQuestionsData",
      "emailAgreementData",
      "eligibilityStep",
    ];

    keysToRemove.forEach((key) => localStorage.removeItem(key));
  };

  return (
    <div className="container-wrapper check-eligible-wrapper">
      <CheckEligibilityModal
        open={openEligibility}
        close={setOpenEligibility}
      />

      <Modal
        opened={opened}
        onClose={close}
        centered
        radius={"xl"}
        size={"lg"}
        withCloseButton={false}
      >
        <div className="modal-content-wrapper">
          <CloseIcon
            style={{
              position: "absolute",
              top: "24px",
              right: "24px",
              cursor: "pointer",
            }}
            onClick={close}
          />
          <ModalIcon />
          <h1 className="header" style={{ color: "#314064" }}>
            Check eligibility
          </h1>
          <p
            style={{ textAlign: "center", color: "#222222" }}
            className="sub-header"
          >
            Check if you're eligible for compensation in less than a minute!
            Answer a few quick questions to see how much you may be entitled to.
          </p>
          <CustomButton
            btnText={"Start My Eligibility Check"}
            flex={1}
            onClick={() => {
              close();
              clearLocalStorage();
              setOpenEligibility(true);
            }}
          />
        </div>
      </Modal>

      <div className="header-text-wrapper">
        <h1 className="header ">What issues qualify for compensation</h1>
        <p className="sub-header text-center">
          Airlines often face disruptions, and as a passenger, you have rights.
          Depending on the circumstances, you could be entitled to compensation
          for the following:
        </p>
      </div>

      <div className="check-eligibity-card-wrapper">
        <div className="check-eligibity-card">
          <div className="absolute-card">
            <OneIcon />
            <div>
              <p className="cart-text">Significant flight delays</p>
              <p className="cart-sub-text">
                If your flight was delayed by more than 3 hours, seriously
                disrupting your travel plans.
              </p>
            </div>
          </div>
          <OneIcon />
          <p className="cart-text">Significant flight delays</p>
        </div>

        <div className="check-eligibity-card">
          <div className="absolute-card">
            <TwoIcon />
            <div>
              <p className="cart-text">Missed flights or denied boarding</p>
              <p className="cart-sub-text">
                If your flight was delayed by more than 3 hours, seriously
                disrupting your travel plans.
              </p>
            </div>
          </div>
          <TwoIcon />
          <p className="cart-text">Missed flights or denied boarding</p>
        </div>

        <div className="check-eligibity-card">
          <div className="absolute-card">
            <ThreeIcon />
            <div>
              <p className="cart-text">Flight cancellations</p>
              <p className="cart-sub-text">
                If your flight was delayed by more than 3 hours, seriously
                disrupting your travel plans.
              </p>
            </div>
          </div>
          <ThreeIcon />
          <p className="cart-text">Flight cancellations</p>
        </div>

        <div className="check-eligibity-card">
          <div className="absolute-card">
            <FourIcon />
            <div>
              <p className="cart-text">Lost or delayed luggage</p>
              <p className="cart-sub-text">
                If your flight was delayed by more than 3 hours, seriously
                disrupting your travel plans.
              </p>
            </div>
          </div>
          <FourIcon />
          <p className="cart-text">Lost or delayed luggage</p>
        </div>
      </div>
      <div className="center" style={{ marginTop: "40px" }}>
        {/* <CustomButton btnText={"Check Your Eligibility"} onClick={open} /> */}
      </div>
    </div>
  );
};

export default CheckEligibility;
